import { HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { EdaApiService } from './eda-api-service';
import { environment } from 'src/environments/environment';
import { SseClient } from 'ngx-sse-client';
import { Observable, switchMap } from 'rxjs';

export interface AgentForceChung {
  type: 'text' | 'end' | 'error';
  content: string;
}

@Injectable({
  providedIn: 'root',
})
export class SalesforceApiService {
  private edaApiService = inject(EdaApiService);
  private sseClient = inject(SseClient);

  initializeSseConnection(): Observable<Event> {
   return this.edaApiService.generateSalesforceToken()
      .pipe(
        switchMap((salesforceToken) => {
          if(!salesforceToken || !salesforceToken.accessToken) {
            throw new Error('No Salesforce token available');
          }
          const sseEndpoint = `${environment.salesForceConfig.domain}${environment.salesForceConfig.sseUrl}`;
          const headers = new HttpHeaders().set('Authorization', `Bearer ${salesforceToken.accessToken}`)
            .set('Content-Type', 'text/event-stream')
            .set('X-Org-Id', environment.salesForceConfig.orgId)
            .set('Cache-Control', 'no-cache')
            .set('Accept', 'text/event-stream');
          return this.sseClient.stream(sseEndpoint,
            { keepAlive: true, reconnectionDelay: 1_000, responseType: 'event' }, { headers }, 'GET');
        }
      )
    )
  }
}
